import assert from '../assert';
import { isValidOperation } from '../operation';

export default op =>
  assert(
    isValidOperation(op),
    `
  Unknown operation specified: ${String(op)}.
  Please use one of
    CREATE
    READ
    UPDATE
    DELETE
`
  );
